import React, { useEffect } from 'react';
import "./Preloader.scss";

const Preloader = (props) => {
    useEffect(() => {
        let body = document.body;
        if (props.active) {
            body.style.overflowY = "hidden";
        } else {
            body.style.overflowY = "auto";
        }

        return () => { body.style.overflowY = "auto"; }
    }, [props.active]);
    return (
        <div className={props.active ? "preloaderWrapper active" : "preloaderWrapper"}>
            <div className="circular-container">
                <div className="circle circular-loader1">
                    <div className="circle circular-loader2"></div>
                </div>
            </div>
        </div>
    )
}

export default React.memo(Preloader);
